const account = {
  displayName: "Jaydon Frankie",
  email: "demo@minimals.cc",
  // photoURL: "/assets/avatar_default.jpg",
  photoURL: "/assets/illustrations/illustration_avatar.png",
  role: "",
};

export default account;
